import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'

// import { Box, ImageWithHandler } from 'components/atoms'
// import { styleRenderer } from 'plugins'
export const StyledMainImageContainer = styled.div`
  height: 0;
  width: 100%;
  padding-top: 100%;
  align-items: center;
  position: relative;
  &[data-in-popup='true'] {
    margin-bottom: 46px;
    ${MediaQueries.mbDown} {
      margin-bottom: 24px;
    }
  }
  &[data-no-bottom-list='true'] {
    margin-bottom: 0;
  }

  ${MediaQueries.tdOnly} {
    padding-top: 54%;
  }
`

export const StyledMainImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`
export const StyledMainImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
  user-drag: none;

  &[data-blur='true'] {
    filter: blur(4px);
    -webkit-filter: blur(4px);
    -moz-filter: blur(4px);
    -o-filter: blur(4px);
    -ms-filter: blur(4px);
  }
`

export const StyledImageItemWrapper = styled.div`
  height: 0;
  /* take account of the border */
  padding-top: calc(100% - 2px);
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.neutral100};
  overflow: hidden;
  &[data-no-border] {
    border: none;
    padding-top: 100%;

    ${MediaQueries.tdOnly} {
      padding-top: 54%;
    }
  }
  &[data-selected='true'] {
    border-color: ${theme.colors.primaryBase};
  }
`

export const StyledImageItemMoreOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const StyledPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: ${theme.colors.gray800};
  display: none;
  &[data-open='true'] {
    display: block;
  }
`
export const PopupButtonStyle = `
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${theme.colors.white};
  border-radius: 50%;
  position: absolute;
  cursor: pointer;
`
export const StyledPopupCloseButton = styled.div`
  ${PopupButtonStyle}
  top: 68px;
  right: 148px;
  ${MediaQueries.mbDown} {
    top: 40px;
    left: 16px;
    width: unset;
    height: unset;
    border: none;
    right: unset;
  }
`
export const StyledPopupLeftButton = styled.div`
  ${PopupButtonStyle}
  top: 50%;
  transform: translateY(-50%);
  left: 148px;
`
export const StyledPopupRightButton = styled.div`
  ${PopupButtonStyle}
  top: 50%;
  right: 148px;
  transform: translateY(-50%);
`
export const StyledPopupContentContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  max-width: min(65vh, 90vw);
  ${MediaQueries.mbDown} {
    width: 100%;
  }
`

export const StyledBottomScrollListWrapper = styled.div`
  .grid-layout {
    grid-gap: 8px;
    grid-template-columns: repeat(var(--carousel-max), 1fr) !important;
  }
  &[data-in-popup='true'] {
    ${MediaQueries.mbDown} {
      padding: 0 16px;
    }
  }
`
